import React, { useState, useEffect } from "react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  console.log("%c Line:22 🍰", "color:#fca650");
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>
            Rudra Surgical - Premium Surgical Gloves Distributor | Healthcare
            Safety Equipment
          </title>
          <meta
            name="description"
            content="Rudra Surgical is a leading distributor of premium quality surgical gloves and medical safety equipment for hospitals, clinics, and healthcare facilities across India. ISO certified products."
          />
          <link rel="canonical" href="https://rudrasurgical.co.in/" />

          {/* Preload critical resources */}
          <link rel="preload" href="/css/bootstrap.css" as="style" />
          <link rel="preload" href="/css/style.css" as="style" />
          <link rel="preload" href="/img/intro-medical.jpg" as="image" />

          {/* Structured Data for better SEO */}
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Rudra Surgical",
                "url": "https://rudrasurgical.co.in",
                "description": "Leading distributor of premium quality surgical gloves and medical safety equipment for healthcare facilities across India.",
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "+91-9099093987",
                  "contactType": "customer service"
                }
              }
            `}
          </script>
        </Helmet>

        <Navigation />
        <Header data={landingPageData.Header} />
        <About data={landingPageData.About} />
        <Services data={landingPageData.Services} />
        <Gallery data={landingPageData.Gallery} />
        {/* <Testimonials data={landingPageData.Testimonials} /> */}
        {/* <Team data={landingPageData.Team} /> */}
        <Contact data={landingPageData.Contact} />
      </div>
    </HelmetProvider>
  );
};

export default App;
